import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

import { AlunoRepository } from '@/pages/admin/repositories/aluno.repository'
import { ViewType } from '../student.admin'
import { Document } from '@/domain/entities/document.entity'

interface ICreateDocument {
  tipo: string
  arquivo: File
}

export interface IStudentProps {
  setLoading: React.Dispatch<React.SetStateAction<Boolean>>
  setDocuments: React.Dispatch<React.SetStateAction<Document[]>>
  setView: React.Dispatch<React.SetStateAction<ViewType>>
}

export const DocumentComponent = ({
  setView,
  setDocuments,
  setLoading,
}: IStudentProps) => {
  const { token } = useAuth()
  const { id } = useParams()
  const [document, setDocument] = useState({} as ICreateDocument)

  async function addDocument() {
    try {
      setLoading(true)
      const newDocument = await AlunoRepository.GetInstance().adminAddDocument(
        id,
        document.arquivo,
        document.tipo.replace(/\s+/g, '_'),
      )
      setDocument({} as ICreateDocument)
      setDocuments((state) => [...state, newDocument])
      setView('DOCUMENTS')
    } catch (error) {
      console.error('error: ', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <input
        value={document?.tipo}
        onChange={(e) =>
          setDocument((state) => ({ ...state, tipo: e.target.value }))
        }
        placeholder="tipo"
      />
      <input
        type="file"
        onChange={(e) =>
          setDocument((state) => ({ ...state, arquivo: e.target.files[0] }))
        }
      />
      <button onClick={addDocument}>Adicionar</button>
      <button onClick={() => setView('DOCUMENTS')}>Cancelar</button>
    </div>
  )
}
